import {EventEmitter, Injectable, Output} from '@angular/core';
import {Participant} from '../../../model/participants/Participant';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class ParticipantFilterService
{
  @Output() participantSelected = new EventEmitter<Participant>();

  public participantList: Participant[];
  public selectedItem: Participant;

  constructor()
  {
  }

}
